import { versionCompare } from '../../lib/common';

export default {
	state: () => ({
		serverAdVideo: {}, // 服务端返回激励广告视频配置
		adrAdVideo: {
			// 安卓client lt v3.0.2 激励视频广告配置
			ad_id: '',
			video_type: '',
			is_template: false,
			url_params: {
				app_position: '',
				ad_id: '',
			},
		},
		adrTaskAd: {
			// 安卓client lt v3.0.2 激励视频任务配置
			task_id: '',
			task_type: '',
			sign: '',
		},
		adrAdVideoGt302: {
			// 安卓client eq && gt v3.0.2 激励视频广告配置
			ad_id: '',
			task_record_id: '',
			ad_source: '',
			ad_type: '',
			is_template: false,
			url_params: {
				app_position: '',
				ad_id: '',
			},
		},
		adrTaskAdGt302: {
			// 安卓client eq && gt v3.0.2 激励视频任务配置
			task_id: '',
			task_type: '',
			task_desc: '',
		},
		interstitialAd: {}, // 安卓插屏广告配置
		videoPos: '', // 调用激励视频位置
	}),
	mutations: {
		setServerAdVideo(state, data) {
			// 设置服务端返回的激励视频配置数据
			state.serverAdVideo = { ...data };
		},
		setVideoPos(state, data) {
			state.videoPos = data;
		},
	},
	actions: {},
	getters: {
		videoReward: (state) => {
			return state.serverAdVideo.ad_reward || 100;
		},
		videoConf:
			(state, rootState) =>
			({ taskConf, privateConf }) => {
				// videoType, privateConf    // 返回客户端视频调用配置
				let clientAdVideo = null;
				let clientAdTask = null;
				let isLt302 = false;

				// 根据客户端版本选择视频参数模版
				if (versionCompare(rootState.client['client-v'], '3.0.2') > -1) {
					clientAdVideo = { ...state.adrAdVideoGt302 };
					clientAdTask = { ...state.adrTaskAdGt302 };
				} else {
					clientAdVideo = { ...state.adrAdVideo };
					clientAdTask = { ...state.adrTaskAd };
					isLt302 = true;
				}
				let { master, fill } = {};

				// 视频参数来源为私有模块传参
				if (privateConf) {
					master = privateConf.master;
					fill = privateConf.fill;
					const { priTaskConf } = privateConf;

					// 将任务配置组装到模版参数中
					Object.assign(clientAdVideo, priTaskConf);
				} else {
					// 视频参数来源为服务端返回公共参数配置
					master = state.serverAdVideo.master;
					fill = state.serverAdVideo.fill;

					if (taskConf) {
						Object.assign(clientAdTask, taskConf);
					}

					Object.assign(clientAdVideo, clientAdTask);
				}

				// 组装结果
				const masterRes = { ...clientAdVideo, ...master };
				const fillRes = { ...clientAdVideo, ...fill };

				const res = {
					master: masterRes,
					fill: fillRes,
				};

				// 根据参数模版修改对应的参数
				if (isLt302) {
					if (master.type && fill.type) {
						res.master.video_type = master.type;
						res.fill.video_type = fill.type;
					}
				} else {
					res.master.task_record_id = res.master.task_id;
					res.fill.task_record_id = res.fill.task_id;

					res.master.ad_type = master.video_type;
					res.fill.ad_type = fill.video_type;

					if (master.type && fill.type) {
						res.master.ad_source = master.type;
						res.fill.ad_source = fill.type;
					}
				}

				return res;
			},
		videoPos: (state) => {
			return state.videoPos;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Video/index.js